'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bTextareaMHasClearYesMSizeMSXsMThemeNormal = (require('./../../levels/common.blocks/textarea/textarea.react.js'), (require('./../../levels/common.blocks/textarea/_has-clear/textarea_has-clear_yes.react.js').default || require('./../../levels/common.blocks/textarea/_has-clear/textarea_has-clear_yes.react.js')).applyDecls());

var _bTextareaMHasClearYesMSizeMSXsMThemeNormal2 = _interopRequireDefault(_bTextareaMHasClearYesMSizeMSXsMThemeNormal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _bTextareaMHasClearYesMSizeMSXsMThemeNormal2.default;